import { useSelector } from "react-redux"
import { getModeledDrafts as getStoreItems } from "selectors"

export const useDrafts = () => {
  const imported: any[] = useSelector(getStoreItems)
  const completed = imported.filter(item => item.complete === true)
  const incomplete = imported.filter(item => item.complete !== true)

  return { imported, completed, incomplete }
}
